import { createTheme } from '@mui/material/styles';
import colors from './colors';

const shadows = {
  ...createTheme({}).shadows,
  1: `0px 4px 8px ${colors.transparentGray['100']}`,
  2: `0px 8px 16px ${colors.transparentGray['150']}`,
};
export default shadows;
